import useLogAction from 'hooks/useLogAction'
import Context from './Context'
import Layout from './Layout'
import useCreateStore from './useCreateStore'
import useFetchData from './useFetchData'
import { useEffect } from 'react'
import useLogNavigation from 'hooks/useLogNavigation'

const FraudUs: React.FC = () => {
  useLogNavigation("Manejo de usuarios y soporte: Usuarios fraudulentos")
  const [states, actions] = useCreateStore()
  const queryHandler = useFetchData(states, actions)

  const props = {
    value: { states, actions, queryHandler }
  }

  return (
    <Context.Provider {...props}>
      <Layout />
    </Context.Provider>
  )
}

export default FraudUs
